module.exports = __webpack_public_path__ + "7615875c.svg";